<template>
  <div class="ECATable">
    <v-container grid-list-md fluid fill-height>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-card>
            <v-expansion-panel
              v-model="panel"
              expand
              popout
            >
              <v-expansion-panel-content>
                <template v-slot:header>
                  <v-card-title class="title">
                    Aplicar Filtros
                  </v-card-title>
                </template>
                <v-card>
                  <v-card-text>
                    <!--Fecha fitiros -->
                    <v-layout wrap justify-space-between>
                      <v-flex xs12 md3>
                        <v-menu
                          :close-on-content-click="false"
                          v-model="menuIni"
                          transition="scale-transition"
                          offset-y
                          full-width
                          :nudge-right="40"
                          max-width="290px"
                          min-width="290px"
                          :disabled="loadingFuida"
                        >
                          <v-text-field
                            slot="activator"
                            label="Fecha Inicial"
                            v-model="dateIni"
                            prepend-icon="event"
                            readonly
                            hint="Debe ser anterior a la fecha final"
                            persistent-hint
                          ></v-text-field>
                          <v-date-picker
                            v-model="dateIni"
                            locale="es-CO"
                            no-title
                            scrollable
                            actions
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-spacer/>
                      <v-flex xs12 md3>
                        <v-menu
                          :close-on-content-click="false"
                          v-model="menuEnd"
                          transition="scale-transition"
                          offset-y
                          full-width
                          :nudge-right="40"
                          max-width="290px"
                          min-width="290px"
                          :disabled="loadingFuida"
                        >
                          <v-text-field
                            slot="activator"
                            label="Fecha Final"
                            v-model="dateEnd"
                            prepend-icon="event"
                            readonly
                            hint="Debe ser posterior a la fecha inicial"
                            persistent-hint
                          ></v-text-field>
                          <v-date-picker
                            v-model="dateEnd"
                            locale="es-CO"
                            no-title
                            scrollable
                            actions
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-spacer/>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="warning"
                :disabled="loadingFuida"
                @click="clear()"
              >
                Limpiar
              </v-btn>

              <v-btn
                color="info"
                :disabled="loadingFuida || loadingTable || vDate"
                @click="loadData()"
              >
                <v-icon left>cloud_download</v-icon> {{ btnText }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex md10>
          <v-card class="mb-2">
            <v-card-title class="title">
              Relacion de cajas y carpetas por cedula
              <v-spacer/>

              <v-card-actions>
                <v-btn color="info" :disabled="dataVals === null">
                  <download-csv
                    :data="dataVals"
                    name="Relacion_cajas_carpetas_cedula.csv"
                    :labels="labels"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                :headers="headers"
                :dataVals="dataVals"
                :searchActive="true"
                :key="tableKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import dataTable from '@/components/Tables/TableExpandWithTotals'
import JsonCSV from 'vue-json-csv'
import moment from 'moment'

export default {
  name: 'ECATable',

  components: {
    'data-table': dataTable,
    'download-csv': JsonCSV
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.loadTable()
  },

  data: function () {
    return {
      backConf: {
        path: '/projects/eca_tb/',
        page: 1
      },

      loadingFuida: false,
      loadingTable: false,
      loading: false,
      loadingDept: false,
      progressSize: 70,
      progressWidth: 7,

      dateIni: null,
      dateEnd: null,
      filter: [],

      filterBy: null,

      headers: [
        {
          text: 'Cédula', align: 'left', value: 'Cédula', str: 'Totales' },
        { text: 'Cajas', value: 'Cajas', align: 'center' },
        { text: 'Carpetas', value: 'Carpetas', align: 'center' }
      ],
      labels: {
        'zona': 'Departamentos',
        'total': 'Total'
      },

      dataVals: null,
      tableKey: 0
    }
  },

  computed: {
    /**
     * Verifica que la fecha final no sea anterior a la fecha inicial
     * @return {string} validación de las fechas
     */
    vDate: function vDate () {
      if (this.dateIni && this.dateEnd) {
        return moment(this.dateEnd).isBefore(this.dateIni)
      }
      return false
    },

    /**
     * Determina el texto que tendra el boton
     * @return {boolean} Texto poara poner en el boton
     */
    btnText: function btnText () {
      if (!this.dateIni && !this.dateEnd) {
        return 'Cargar Todos'
      }
      return 'Cargar con Filtro'
    },

    /**
     * Genera el objeto para realizar la consulta
     * @return {Object} Objeto de la forma id[field]:id[choice]
     */
    filterToApply: function filterToApply () {
      if (this.filter.length < 1) {
        return null
      }

      let obj = {}

      this.filterBy.forEach(function (filt, index) {
        obj[filt.id] = this.filter[index]
      }, this)
      return obj
    }
  },

  methods: {
    /** Carga la tabla
     */
    loadTable () {
      this.loadingFuida = true
      this.loading = true
      this.dataVals = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          fechainicio: this.dateIni,
          fechafin: this.dateEnd
        }
      }

      let t = this

      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = resp.data
          t.loadingFuida = false
          t.loading = false
          t.tableKey += 1
        })
        .catch(function (err) {
          t.dataVals = []
          t.loading = false
          t.loadingFuida = false
          console.error(err)
        })
    },

    loadFiltro () {
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo,
          tipo: 'filtro'
        }
      }
      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.filterBy = resp.data
        })
        .catch(function (err) {
          t.filterBy = null
          console.error(err)
        })
    },
    loadData () {
      this.loadTable()
      this.panel = [false]
    },
    clear () {
      this.dateIni = null
      this.dateEnd = null
      this.filter = []
    }

  }
}
</script>
